import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const IndustryClient = () => {
  return (
    <SettingsMetaData propertyName={"Industry_Client"} viewPropertyName={"Industry"} />
  );
};
export default IndustryClient;